import i18n from '../translation/i18n';

// 근태 일정 결재 상태(approvalStatus)별 표시 문구 - 최종승인(APPROVED)·일반 일정(null)은 표시하지 않음
const APPROVAL_STATUS_LABEL: Record<string, string> = {
  PENDING: '결재중',
  HOLD: '보류',
};

/**
 * 근태 일정명 끝에 결재 상태를 붙인다. (예: 홍길동 연차 → 홍길동 연차 [결재중])
 * 결재중·보류가 아니면 일정명을 그대로 반환
 */
export const appendApprovalStatus = (name: string, approvalStatus?: string | null) => {
  const label = approvalStatus ? APPROVAL_STATUS_LABEL[approvalStatus] : undefined;
  return label ? `${name} [${i18n.t(label)}]` : name;
};
